import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GroupDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss']
})
export class GroupComponent implements OnChanges {

  groupForm: FormGroup;
  groupFormArray: FormGroup;
  control = new FormControl();
  @Input() groups: GroupDto[];
  @Input() routeAnimationsElements: any;
  @Output() group = new EventEmitter<GroupDto[]>()
  @Output() deleteGroupEvent = new EventEmitter<any>()

    selectedGroup: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createGroupForm();
    }

    createGroupForm() {
      this.groupForm = this.fb.group({
        GroupName: ['', Validators.required],
        id: null
        });
        this.groupFormArray = this.fb.group({ Groups: this.fb.array([])
          });
        this.setGroup();
    }

  // method to display groups
  setGroup() {
    const control  = this.groupFormArray.controls.Groups as FormArray;
    this.groups.forEach( e => {
      control.push(
        this.fb.group({
          GroupName: e.GroupName,
          id: e.id
        })
      );
    });
  }


  // method to add Group
  addGroup(value: GroupDto) {
    const control  = this.groupFormArray.controls.Groups as FormArray;
    control.insert(0,
          this.fb.group({
            GroupName: value.GroupName,
            id: null
          })
       );
  }

  selectGroup(value) {}

  // method to delete group from arrary list
  deleteGroup(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.groupFormArray.controls.Groups as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.groups.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.groups[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: GroupDto) {
    if(this.groupForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.groupFormArray.get('Groups')['controls'][this.selectedIndex].patchValue({GroupName: formValue.GroupName});
    } else {
      this.addGroup(formValue);
    }
    this.selectedIndex = null;
    this.groupForm.reset()
  }

  onEdit(index, value: GroupDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.groupForm.patchValue({GroupName: value.GroupName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.groupForm.reset();
  }

  onSubmit(formValue: GroupDto[]) {
  this.group.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteGroupEvent.emit(this.filteredDelete);
  }
  }

}
